import { GridColDef } from "@mui/x-data-grid";
import { PublicKeyLink } from "components/PublicKeyLink";
import EditMenuItem from "components/table/EditMenuItem";
import { MoreActionsButton } from "components/table/MoreActionsButton";
import { MembershipType, ofMembershipType } from "../types/membershipType";
import { Coin } from "../types/coin";
import { ImageColumn } from "../components/table/ImageColumn";
import DeleteMenuItem from "../components/table/DeleteMenuItem";
import CoinAmount from "../components/CoinAmount";

export const membershipTypeCols = (props: {
  coin?: Coin | null;
}): GridColDef<MembershipType>[] => {
  const optionalCoinCol: GridColDef<MembershipType>[] = props.coin
    ? [
        {
          field: ofMembershipType("includedCoinAmount"),
          headerName: "Included Coin",
          flex: 1,
          filterable: false,
          renderCell: ({ row }) => (
            <CoinAmount amount={row.includedCoinAmount} />
          ),
        },
      ]
    : [];
  return [
    {
      field: ofMembershipType("image"),
      headerName: "Image",
      renderCell: function render({ row }) {
        return <ImageColumn imageUrl={row.image?.url ?? row.imageUrl ?? ""} />;
      },
      minWidth: 120,
      sortable: false,
      flex: 1,
    },
    {
      field: ofMembershipType("name"),
      headerName: "Name",
      flex: 1,
    },
    {
      field: ofMembershipType("symbol"),
      headerName: "Symbol",
      flex: 1,
    },
    ...optionalCoinCol,
    {
      field: ofMembershipType("membershipCount"),
      headerName: "Count",
      description: "Count of memberships of this type",
      type: "number",
      minWidth: 100,
    },
    {
      field: ofMembershipType("membershipKey"),
      headerName: "Mint Key",
      renderCell: function render({ row }) {
        return (
          <PublicKeyLink
            pubKey={row.membershipKey}
            linkToSolanaExplorer={!!row.blockchainImportId}
          />
        );
      },
      flex: 1,
      minWidth: 100,
      sortable: false,
    },
    {
      field: "menu",
      headerName: "",
      renderCell: function render({ row }) {
        return (
          <MoreActionsButton>
            {row.blockchainImportId == null ? (
              <EditMenuItem resource="membership-types" id={row.id} />
            ) : null}
            <DeleteMenuItem resource="membership-types" id={row.id} />
          </MoreActionsButton>
        );
      },
      align: "center",
      maxWidth: 80,
      filterable: false,
      sortable: false,
      disableExport: true,
      disableColumnMenu: true,
    },
  ];
};
